<template>
  <el-dialog :visible.sync="priceBrandDialog" width="25%" :title="titleDialog" class="addBrand">
    <el-form :model="queryParams" style="padding-left:32px" label-position="left">
      <el-row>
        <el-col :span="18">
          <el-form-item label="品牌：" label-width="42px">
            <el-select
              v-if="isEdit"
              v-model="brandData"
              value-key="id"
              filterable
              placeholder="请选择品牌"
            >
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.brandName"
                :value="item"
              ></el-option>
            </el-select>
            <span v-if="!isEdit">{{brandData.brandName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="协议设置：" label-width="70px">
            <el-select
              v-model="queryParams.templateType"
              @change="onChange(queryParams.templateType)"
            >
              <el-option label="折扣价" :value="1"></el-option>
              <el-option label="加价率" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="比例：" label-width="45px" v-if="title==='比例：'">
            <el-col :span="20">
              <el-input v-model="queryParams.templateRate"></el-input>
            </el-col>
            <el-col :span="4" class="add-right">
              <span>%</span>
            </el-col>
          </el-form-item>
          <el-form-item label="百分比：" label-width="56px" v-else>
            <el-col :span="20">
              <el-input v-model="queryParams.templateRate"></el-input>
            </el-col>
            <el-col :span="4" class="add-right">
              <span>%</span>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirm">确 定</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  customerPriceBraSerProUpdate,
  customerPriceBrSerProAdd,
  customerPriceTemplateCustomerUpdate,
  customerPriceTemplateCustomerAdd,
  queryByCptIdBrand
} from '@/api/customer/customerManage'
export default {
  props: ['cptId'],
  data () {
    return {
      priceBrandDialog: false,
      queryParams: {
        brandId: '',
        brandName: '',
        templateRate: '',
        templateType: 1,
        priceType: '1'
      },
      brandData: {},
      brandList: [], // 品牌名称
      currentPage: 1, // 页码
      pageSize: 60, // 当前页数
      title: '比例：',
      titleDialog: '',
      type: 1,
      isEdit: false,
      paramsBrand: {},
      isClick: 0 // 同步至模板状态,0默认不可同步,1数据发生改变可以同步至模板
    }
  },
  methods: {
    // 添加协议价品牌初始方法
    priceBrandAddInitial (type, val) {
      // type=1是前端做添加数据,2是需要调用后端添加,3是需要调用后端接口添加
      this.queryParams = {
        brandId: '',
        brandName: '',
        templateRate: '',
        templateType: 1,
        priceType: '1'
      }
      this.brandData = {}
      this.priceBrandDialog = true
      this.type = type
      if (type === 1 || type === 3 || type === 5) {
        // 1协议价模板前端添加数据不调用后端接口,3协议价模板详情添加,5客户协议价品牌添加调用接口
        this.titleDialog = '添加协议价品牌'
        this.title = '比例：'
        this.isEdit = true
        this.getBrandQueryPageAll()
      } else if (type === 2 || type === 4) {
        // 2协议价模板详情编辑,4客户协议价品牌编辑
        this.isEdit = false
        this.titleDialog = '编辑'
        this.title = '百分比：'
        this.paramsBrand = val
        this.queryParams = {
          templateType: val.templateType,
          templateRate: val.templateRate * 100
        }
        this.brandData.brandName = val.brandName
      }
    },
    // 获取品牌名称
    getBrandQueryPageAll () {
      queryByCptIdBrand(this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.brandList = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 协议设置
    onChange (val) {
      if (val === 1) {
        this.title = '折扣额度：'
        this.queryParams.templateRate = ''
      } else {
        this.title = '加价率：'
        this.queryParams.templateRate = ''
      }
    },
    // 确定
    onConfirm () {
      this.queryParams.brandName = this.brandData.brandName
      this.queryParams.brandId = this.brandData.id
      if (this.type === 1) {
        // 前端做添加数据
        this.$emit('onAddTemplate', this.queryParams)
        this.priceBrandDialog = false
      } else if (this.type === 2) {
        // 调用后端接口协议价模板进行编辑
        const params = {
          cptId: this.paramsBrand.cptId,
          id: this.paramsBrand.id,
          templateType: this.queryParams.templateType,
          templateRate: this.queryParams.templateRate * 0.01,
          priceType: '1'
        }
        customerPriceBraSerProUpdate(params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('操作成功!')
              this.priceBrandDialog = false
              this.$router.push({ query: { id: res.data.obj.cptId } })
              this.$emit('getListBrand')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (this.type === 3) {
        // 调用后端接口协议价模板进行添加
        const params = this.queryParams
        params.cptId = this.$route.query.id
        const paramsList = []
        paramsList.push(params)
        customerPriceBrSerProAdd(paramsList)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('添加成功!')
              this.priceBrandDialog = false
              this.$emit('getListBrand')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (this.type === 4) {
        // 调用后端接口客户协议价模板进行编辑
        const params = {
          cptId: this.paramsBrand.cptId,
          id: this.paramsBrand.id,
          templateType: this.queryParams.templateType,
          templateRate: this.queryParams.templateRate * 0.01,
          priceType: '1'
        }
        customerPriceTemplateCustomerUpdate(params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('操作成功!')
              this.isClick = 1
              this.$emit('getListBrand', this.isClick)
              this.priceBrandDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (this.type === 5) {
        // 调用后端接口客户协议价添加品牌
        const params = JSON.parse(JSON.stringify(this.queryParams))
        params.templateRate = params.templateRate * 0.01
        params.cptId = this.cptId
        const paramsList = []
        paramsList.push(params)
        customerPriceTemplateCustomerAdd(this.$route.query.id, paramsList)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('添加成功!')
              this.isClick = 1
              this.$emit('getListBrand', this.isClick, 'priceBrand')
              this.priceBrandDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 取消
    onCancel () {
      this.priceBrandDialog = false
    }
  }
}
</script>

<style>
</style>
